import { FC, useRef } from 'react';

import { useAppDispatch } from 'hooks/redux';
import HalfScreenModal from 'components/HalfScreenModal/HalfScreenModal';
import RichTextEditor from 'components/RichTextEditor/RichTextEditor';
import { createRichMedia } from 'modules/newHireChecklist/slices/nhcSlice';
import { SectionName } from 'modules/home/constants';
import { PLAN_DESCRIPTION_WORD_LIMIT } from 'modules/benefitsWellness/constants/BenefitConstants';

type ResourceTextEditorProps = {
  isOpenModal: boolean;
  closeModal: Function;
  editorContent: string;
  updateEditorContent: (data: string) => void;
  resetToDefault: () => void;
  isResetEnabled: boolean;
  benguideId?: string;
  defaultContent?: string;
  resetToCurrentValue: Function;
  onCreate: Function;
};

const ResourceTextEditor: FC<ResourceTextEditorProps> = (
  props: ResourceTextEditorProps
) => {
  const {
    isOpenModal,
    closeModal,
    editorContent,
    updateEditorContent,
    resetToDefault,
    isResetEnabled,
    benguideId,
    defaultContent,
    resetToCurrentValue,
    onCreate,
  } = props;
  const textEditorRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const resetContent = () => {
    resetToDefault();
  };

  const closeOverviewModal = () => {
    resetToCurrentValue();
    if (textEditorRef.current) {
      textEditorRef.current.clearTextEditorContent();
    }
    closeModal();
  };

  const handleEditorChange = (data: string) => {
    updateEditorContent(data);
  };

  const handleSubmit = () => {
    if (benguideId)
      dispatch(
        createRichMedia(
          benguideId,
          SectionName.RESOURCES_TEXT,
          editorContent,
          onCreate
        )
      );
    closeModal();
  };

  return (
    <HalfScreenModal
      width={900}
      title="Resources"
      visible={isOpenModal}
      onReset={resetContent}
      onCancel={closeOverviewModal}
      onSubmit={handleSubmit}
      confirmModalShow
      isResetEnabled={isResetEnabled}
      increaseResetSpacing
      afterClose={() => {
        textEditorRef?.current?.resetUndo();
        textEditorRef?.current?.clearSelection();
      }}
    >
      <RichTextEditor
        limit={PLAN_DESCRIPTION_WORD_LIMIT}
        initialValue={defaultContent}
        onChange={handleEditorChange}
        defaultText={editorContent}
        ref={textEditorRef}
        masterId={benguideId}
        height={600}
      />
    </HalfScreenModal>
  );
};

export default ResourceTextEditor;
